import * as React from "react";
import { Card as AntdCard } from "antd";

type CardProps = {
  title: string;
  tableMode: boolean;
  marginBottom: boolean;
  children?: JSX.Element;
};

export default function Card({
  title: propsTitle,
  children: propsChildren,
  marginBottom: propsMarginBottom,
  tableMode: propsTableMode,
}: CardProps) {
  return (
    <AntdCard
      className={propsTableMode && "card-table"}
      title={propsTitle}
      style={{ marginBottom: propsMarginBottom ? 24 : 0 }}
    >
      {propsChildren}
    </AntdCard>
  );
}
